module.exports = __webpack_public_path__ + "static/media/linkedinn.503c5959.svg";